import { Component, OnInit, Input, ViewChild } from '@angular/core';
import * as $ from 'jquery';
import { Router, ActivatedRoute, ParamMap, NavigationExtras } from '@angular/router';
import { SharedService } from '../../services/shared/shared.service';
import { NgForm, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Md5 } from 'ts-md5/dist/md5';
// import { UserManagementService } from '../../services/user-management/user-management.service';
import { UsersService } from '../../services/users/users.service';
import { PATTER_VALIDATION, COMMONTEXT, COMMON } from '../../app.constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @ViewChild('passwordPopup') public passwordPopup: ModalDirective;
  userName;
  @Input() enableSideMenu: any;
  formSubmitted = false;
  passwordForm: FormGroup;
  updateDisable = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sharedService: SharedService,
    private usersService: UsersService,
  ) { }

  ngOnInit() {
    this.initializeForm();
    // console.log('enableSideMenu ')
    $(function ($) {

      $(".sidebar-dropdown > a").click(function () {
        $(".sidebar-submenu").slideUp(300);
        if (
          $(this)
            .parent()
            .hasClass("active")
        ) {
          $(".sidebar-dropdown").removeClass("active");
          $(this)
            .parent()
            .removeClass("active");
        } else {
          $(".sidebar-dropdown").removeClass("active");
          $(this)
            .next(".sidebar-submenu")
            .slideDown(300);
          $(this)
            .parent()
            .addClass("active");
        }
      });



      $("#show-sidebar").click(function () {
        $(".page-wrapper").toggleClass("active");
      });

    });



    // $(window).bind("resize", function () {
    //   if ($(this).width() < 1026) {
    //     $('.page-wrapper').removeClass('active');
    //   } else {
    //     $('.page-wrapper').addClass('active');

    //   }
    // }).trigger('resize');


    $('.nav-icon').click(function () {
      $(this).toggleClass('open');
    });

    this.sharedService.getLocalStorageItem('user').then((resp: any) => {
      if (resp) {
        this.userName = resp.name
      }
    })




  }

  initializeForm() {
    this.passwordForm = new FormGroup({
      oldPassword: new FormControl('', Validators.required),
      newPassword: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required),
    })
  }


  logOut() {
    this.sharedService.confirm(COMMONTEXT.POP_UP_HEADER, COMMONTEXT.LOGOUT, 'md').then((resp: any) => {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          reload: true
        }
      };
      if(resp == true) {
        this.usersService.logout().then((resp: any) => {
          this.router.navigateByUrl('/Login', navigationExtras)
        }, (error) => {
          console.log('error  ', error)
          this.router.navigateByUrl('/Login', navigationExtras)
        })
      } 
    })
  }

  profile() {
    // const navigationExtras: NavigationExtras = {
    //   queryParams: {
    //     reload: true
    //   }
    // };
    this.router.navigateByUrl('/Profile')
    
  }

  build(){
    this.router.navigateByUrl('/Build-and-Releases')
  }

  changePassword() {
    this.formSubmitted = false;
    this.passwordPopup.show();
  }

  updatePassword1() {
    this.passwordPopup.config = { backdrop: 'static', keyboard: false }

    this.formSubmitted = true;
    if (this.passwordForm.valid) {

      this.updatePassword();
    }
  }

  updatePassword() {
    if ((this.passwordForm.controls['oldPassword'].value) != (this.passwordForm.controls['newPassword'].value)) {
      if ((this.passwordForm.controls['newPassword'].value) == (this.passwordForm.controls['confirmPassword'].value)) {

        const md5 = new Md5();
        const md6 = new Md5();
        const md7 = new Md5();
        const obj = {
          oldPassword: md5.appendStr(this.passwordForm.controls['oldPassword'].value).end(),
          newPassword: md6.appendStr(this.passwordForm.controls['newPassword'].value).end(),
          confirmPassword: md7.appendStr(this.passwordForm.controls['confirmPassword'].value).end(),
        }
        this.usersService.changeInternalUserPassword(obj).then((resp: any) => {
          if (resp.status == 200) {
            if (resp['body']['responseCode'] == 200) {
              this.sharedService.showSuccess(resp['body']['responseDesc']);
              this.router.navigateByUrl('/Login')
              this.hidePasswordPopUp();
            } else {
              this.sharedService.showError(resp['body']['responseDesc'])
            }
          }
        })
      } else {
        this.sharedService.showWarning(COMMONTEXT.PASSWORD_MATCH);
      }
    } else {
      this.sharedService.showWarning(COMMONTEXT.OLD_NEW_MATCH);
    }

  }


  hidePasswordPopUp() {
    this.formSubmitted = false;
    this.passwordForm.reset();
    this.passwordPopup.hide();
  }
}
